import * as THREE from 'three';
import { createPointMaterial } from '../common/PointMaterial.js';

export default class PointCloud {

    constructor() {

        const count = 4000;

        const pos = new Float32Array(count * 3);
        const scale = new Float32Array(count);

        for (let i = 0; i < count; i++) {

            // Promień chmury
            const r = Math.random() * 4.5;

            // Losowe położenie punktu
            const t = Math.random() * Math.PI * 2;
            const p = Math.acos(2 * Math.random() - 1);

            pos[i * 3] =
                r * Math.sin(p) * Math.cos(t);

            pos[i * 3 + 1] =
                r * Math.sin(p) * Math.sin(t);

            pos[i * 3 + 2] =
                r * Math.cos(p);

            // Wielkość punktu
            scale[i] = 0.8 + Math.random() * 1.4;

        }

        const g = new THREE.BufferGeometry();

        g.setAttribute(
            'position',
            new THREE.BufferAttribute(pos, 3)
        );

        g.setAttribute(
            'scale',
            new THREE.BufferAttribute(scale, 1)
        );
	console.log(g.getAttribute('scale'));
        this.object = new THREE.Points(
            g,
            createPointMaterial()
        );

    }

    update(dt) {

        this.object.rotation.y += dt * 0.08;

    }

}
